<script setup lang="ts">
import type { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

import { useSlotDaysOfWeek } from '../../model/slots/days-of-week.hook'
import SlotsHeaderTab from './SlotsHeaderTab.vue'

defineOptions({
  name: 'SlotsDaysHeader',
})

defineProps<{
  tabs: SlotsDayTab[]
  selected: ShortDaysOfWeek
}>()

const emit = defineEmits<{
  select: [ShortDaysOfWeek]
}>()

interface SlotsDayTab {
  id: ShortDaysOfWeek
  point: boolean
}

const { days } = useSlotDaysOfWeek()
</script>

<template>
  <div class="slots-header">
    <SlotsHeaderTab
      v-for="tab in tabs"
      :id="tab.id"
      :key="tab.id"
      :text="days[tab.id]"
      :selected="tab.id === selected"
      :point="tab.point"
      @click="emit('select', $event)"
    />
  </div>
</template>

<style scoped lang="scss" src="./SlotsDaysHeader.scss" />
